"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHublVariableLabel = exports.getEmailSystemHublVar = exports.EmailSystemHublVariables = exports.getHublVariable = exports.HUBL_VAR_REGEXP = void 0;

var _i18n = require("./i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)('TinymcePlugins.hslink.emailSystemLinks');
var HUBL_VAR_REGEXP = /^{{\s*([a-zA-Z0-9_.]+)\s*}}$/;
exports.HUBL_VAR_REGEXP = HUBL_VAR_REGEXP;

var getHublVariable = function getHublVariable(str) {
  if (typeof str !== 'string') {
    return null;
  }

  var matches = str.trim().match(HUBL_VAR_REGEXP);
  return matches ? matches[1] : null;
};

exports.getHublVariable = getHublVariable;
var EmailSystemHublVariables = {
  UNSUBSCRIBE: 'unsubscribe_link',
  UNSUBSCRIBE_ALL: 'unsubscribe_link_all',
  VIEW_AS_WEBPAGE: 'view_as_page_url',
  SUBSCRIPTION_CONFIRMATION: 'subscription_confirmation_url'
};
exports.EmailSystemHublVariables = EmailSystemHublVariables;

var getEmailSystemHublVar = function getEmailSystemHublVar(str) {
  var hublVar = getHublVariable(str);

  for (var key in EmailSystemHublVariables) {
    if (hublVar === EmailSystemHublVariables[key]) {
      return hublVar;
    }
  }

  return null;
};

exports.getEmailSystemHublVar = getEmailSystemHublVar;

var getHublVariableLabel = function getHublVariableLabel(name) {
  switch (name) {
    case EmailSystemHublVariables.UNSUBSCRIBE:
      return i18nKey('unsubscribe');

    case EmailSystemHublVariables.UNSUBSCRIBE_ALL:
      return i18nKey('unsubscribeAll');

    case EmailSystemHublVariables.VIEW_AS_WEBPAGE:
      return i18nKey('viewAsWebpage');

    case EmailSystemHublVariables.SUBSCRIPTION_CONFIRMATION:
      return i18nKey('subscriptionConfirmation');

    default:
      return name;
  }
};

exports.getHublVariableLabel = getHublVariableLabel;